import {SistemaColor} from "../../components/helpers/Sistema";
import {useState} from 'react';
import Modal from 'react-bootstrap/Modal';
import {Checkbox} from "../contratos/TablaContratos";
import dayjs from "dayjs";
import {axiosInstance} from "../../components/helpers/axiosInstance";
import relativeTime from "dayjs/plugin/relativeTime";
import es from "dayjs/locale/es";
import isBetween from 'dayjs/plugin/isBetween'
import { useToast } from "../../components/notificaciones/ToastProvider";
import TitleTooltip from "../../components/helpers/TitleTooltip";
export default function TablaTickets({
     toggleShow,
     tickets
 }) {

    const ticketlist = tickets && tickets.map((t) => t.id_ticket);
    const [selected, setSelected] = useState([]);
    dayjs.locale(es);
    dayjs.extend(relativeTime);
    dayjs.extend(isBetween);

    const handleSelect = (value, name) => {
        if (value) {
            setSelected([...selected, name]);
        } else {
            setSelected(selected.filter((item) => item !== name));
        }
    };

    function selectAll(value) {
        if (value) {
            setSelected(ticketlist);
        } else {
            setSelected([]);
        }

    }

    return (
        <>
            <div className="table-responsive">
                <table className="table table-row-dashed table-row-gray-300 align-middle gy-3 gx-2">
                    <thead>
                    <tr className="fw-bold text-muted">
                        <th className="pb-5">
                            <Checkbox name={"all"} value={selected.length === ticketlist.length}
                                      updateValue={selectAll}></Checkbox>
                        </th>
                        <th colSpan="5" style={{paddingLeft: 0, minWidth: "320px"}}>
                            <TitleTooltip title={"Archivar"} placement={'top'}>
                                <button className="btn btn-sm btn-icon btn-active-light btn-active-icon-primary me-2">
                                    <i className="ki-outline ki-archive fs-2"></i>
                                </button>
                            </TitleTooltip>
                        </th>
                        <th className="w-100 pb-5">REPORTADO</th>
                        <th className="pb-5" style={{minwidth: "110px"}}>REPORTADO</th>
                        <th className="pb-5 min-w-100px">ACCIONES</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        tickets && tickets.length > 0 && tickets.map(
                            /**
                             *
                             * @param t
                             * @prop t.reporta
                             * @prop t.asunto
                             * @prop t.alta
                             * @returns {JSX.Element}
                             */
                            (t) => {
                            return (
                                <tr key={t.id_ticket} className=""> {/*verificar si hubo actividad : true && "table-warning" */}
                                    <td>
                                        <Checkbox name={t.id_ticket} value={selected.includes(t.id_ticket)}
                                                  updateValue={handleSelect}></Checkbox>
                                    </td>
                                    <td>
                                        <div className="d-flex align-items-center mt-2">
                                            <div className="d-flex flex-column text-center">
                                                <div> {/*verificar si hay archivos : true && "d-none" */}
                                                    <i className="ki-solid ki-paper-clip fs-3 text-primary"></i>{/*verificar si hubo actividad : true && "text-warning" */}
                                                </div>
                                                <div
                                                    className="d-block"> {/* verificar si hay comentarios : true && "d-none" */}
                                                    <i className="bi bi-chat-left fs-5 text-primary"></i> {/* verificar si hubo actividad : true && "text-warning" */}
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <TitleTooltip title={"Prioridad " + prioridad(t.prioridad).texto} placement={'top'}>
                                            <span className={"bullet bullet-vertical h-40px bg-" + (t.estatus === 'Concluido' ? 'gray-200' : prioridad(t.prioridad).color)}></span>
                                        </TitleTooltip>
                                    </td>
                                    <td>
                                        <TitleTooltip title={t.estatus} placement={'top'}>
                                            <i className={"bi bi-ticket-perforated fs-4x text-" + estatus(t.estatus)}></i>
                                        </TitleTooltip>
                                    </td>
                                    <td>
                                        <TitleTooltip title={"Atiende: Octavio Hdz"} placement={'top'}>
                                            <div className="symbol symbol-35px">
                                              <span className="symbol-label Mg fs-4">
                                                Mg
                                              </span>
                                            </div>
                                        </TitleTooltip>
                                    </td>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <div className="ms-n1 me-2">
                                                <SistemaColor sistema={'BGDL'}></SistemaColor>
                                            </div>
                                            <div className="d-flex flex-column fs-6">
                                                <span>Bolet&iacute;n GDL</span>
                                                <div className="d-block font-monospace">{t.ticket}</div>
                                            </div>
                                        </div>
                                    </td>
                                    <td style={{minWidth: "250px", maxWidth: "1px"}}>
                                        <div className="d-flex text-nowrap overflow-hidden fs-6">
                                            <div className="d-flex flex-column">
                                                <button onClick={(e) => toggleShow(e, t.id_ticket, t.ticket)}
                                                        className="btn p-0 lh-base text-start text-uppercase text-gray-900 text-hover-primary fw-semibold">
                                                    gdlmedina01 - {t.reporta}
                                                </button>
                                                <div className="d-block text-muted">
                                                    {t.asunto} : {t.descripcion}
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td style={{minWidth: '110px'}}>
                                        <div className="d-flex flex-column w-100">
                                            <div className="d-flex flex-stack fw-semibold fs-4 text-center">
                                                <span className="d-block fs-6 mb-1 text-capitalize">{dayjs(t.alta.slice(0,10)).format('MMM. DD, YYYY')}</span>
                                            </div>
                                            <div>
                                                <span className={"fw-normal badge badge-" + colorFecha(t.alta)}>{dayjs(t.alta).fromNow()}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="text-end">
                                        <ArchivarTicket id={t.id_ticket}></ArchivarTicket>
                                    </td>
                                </tr>
                            );
                        })
                    }
                    </tbody>
                </table>
            </div>
            <div className="d-flex flex-stack flex-wrap flex-column-reverse py-3  flex-md-column-fluid">
                <div className="fs-6 fw-semibold text-gray-700 py-2">Registros del <span
                    className="fw-bolder">1</span> al <span className="fw-bolder">15</span> de <span
                    className="fw-bolder">99</span> resultados.
                </div>
                <ul className="pagination">
                    <li className="page-item previous">
                        <button className="page-link">
                            <i className="previous"></i>
                        </button>
                    </li>
                    <li className="page-item active">
                        <button className="page-link">1</button>
                    </li>
                    <li className="page-item">
                        <button className="page-link">2</button>
                    </li>
                    <li className="page-item">
                        <span className="page-link">...</span>
                    </li>
                    <li className="page-item">
                        <button className="page-link">98</button>
                    </li>
                    <li className="page-item">
                        <button className="page-link">99</button>
                    </li>
                    <li className="page-item next">
                        <button className="page-link">
                            <i className="next"></i>
                        </button>
                    </li>
                </ul>
            </div>
        </>
    );
}

function ArchivarTicket({
    id
}) {
    const [showArch, setShowArch] = useState(false);
    const toast = useToast();

    function deleteTicket(){
        axiosInstance.delete('/tickets/' + id)
            .then(res => {
                if (res.status === 200){
                    setShowArch(false);
                    toast.setArrayToast(
                        prevState => [
                            ...prevState,
                            {
                                id : id,
                                text : 'Ticket archivado',
                                color : 'success',
                                show: true,
                            }
                        ]
                    );
                }
            })
            .catch(err => {
                setShowArch(false);
                toast.setArrayToast(
                    prevState => [
                        ...prevState,
                        {
                            id : id,
                            text : 'Hubo un error:' + err.data,
                            color : 'danger',
                            show: true,
                        }
                    ]
                );
            })
    }

    return (
        <>
            <TitleTooltip title={"Archivar"} placement={'top'}>
                <button
                    className="btn btn-sm btn-icon btn-active-light btn-active-icon-primary me-2"
                    onClick={() => setShowArch(true)}>
                    <i className="ki-outline ki-archive fs-2"></i>
                </button>
            </TitleTooltip>

            <Modal show={showArch} onHide={() => setShowArch(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Archivar ticket</Modal.Title>
                </Modal.Header>
                <Modal.Body>¿Seguro que quieres archivar el ticket?</Modal.Body>
                <Modal.Footer>
                    <button className={'btn btn-secondary'} onClick={() => setShowArch(false)}>
                        Cerrar
                    </button>
                    <button className={'btn btn-primary'} onClick={deleteTicket}>
                        Archivar
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export function estatus(estatus) {
    switch (estatus) {
        case "Concluido":
            return 'gray-200'
        case "Reportado":
            return 'muted'
        case "Cocinandose":
            return 'success'
        case "Postergado":
            return 'info'
        default:
            return 'muted'
    }
}

export function prioridad(prioridad){
    switch (prioridad){
        case 'A':
            return { color: 'danger', texto: 'Alta'};
        case 'B':
            return { color: 'muted', texto: 'Baja'};
        default:
            return { color: 'transparent', texto: 'Normal'};
    }
}

export function colorFecha(f){
    const hoy = dayjs();
    const fecha = dayjs(f);
    const dia2 = dayjs(f).add(2, 'day');

    if (dayjs(f).isSame(hoy)){
        return 'info'
    } else if (dayjs().isBetween(fecha, dia2)){
        return 'warning';
    } else {
        return 'danger'
    }
}
